import React from 'react';
import { motion } from 'framer-motion';
export function Conclusion() {
  return <section className="py-32 px-6 bg-cream text-center" data-id="element-23">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="text-4xl md:text-5xl mb-8" data-id="element-25">
          Ya no eres la misma persona
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-charcoal-light leading-relaxed font-light" data-id="element-26">
          <p data-id="element-27">
            Al llegar a este punto, espero que sientas un peso menos sobre tus
            hombros. Salvar un matrimonio no es una carga que debes llevar con
            desesperación, sino un proceso de maestría personal.
          </p>
          <p data-id="element-28">
            Has aprendido que el poder no reside en controlar al otro, sino en
            controlarte a ti mismo y en cómo reaccionas ante la tormenta. En 90
            días, si sigues estas pautas, la persona que hoy parece un extraño
            volverá a ser tu confidente.
          </p>
          <p data-id="element-29">
            Pero lo más importante es que tú ya no dependerás del estado de
            ánimo de nadie para sentirte completo/a. Has recuperado tu centro.
            El matrimonio es un jardín: ahora tienes las herramientas para
            quitar la maleza y permitir que la vida vuelva a brotar.
          </p>
        </div>

        <div className="mt-16" data-id="element-30">
          <p className="font-serif italic text-3xl md:text-4xl text-navy" data-id="element-31">
            "No te rindas, lo mejor está por venir."
          </p>
        </div>
      </motion.div>
    </section>;
}